import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../constants/globalConstants'
import { userLogin, userSingUp } from '../../redux/actions/login'
import { useNavigate } from 'react-router-dom'
import URL from '../../constants/urls'
import { Circles } from 'react-loader-spinner'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import { useForm, Controller } from 'react-hook-form'
import { createDefaultMaskGenerator, MaskedInput } from 'react-hook-mask'
import './login.css'
import { getConfigDetails } from '../../services/config'
import { encodePasswordBase, isPermissionExist, restrictInputValues, restrictInValidCharPassword, restrictSpecialChar, sortPortalPermissionByKey, validatePassword } from '../../utils/helper'
import { getVehicleDetailsList, getVehicleModelList } from '../../redux/actions/VehicleListAction'
import { Form } from 'react-bootstrap'
import { getLoggedUserData } from '../../utils/HelperEvent'
const phoneMaskGenerator = createDefaultMaskGenerator('(999) 999-99999')

function Login(props) {

    const { dispatch, notify, useFor, stateData, countryData, partnerDetails, bookingPartnerDetails } = props
    const { register, handleSubmit, formState: { errors }, control, reset, setValue, getValues } = useForm()
    // const handleClose = () => {
    //     setModalSignup(0)
    // }
    const navigate = useNavigate()
    const partner = window.location.toString().split('/')[3]
    const [modalSingup, setModalSignup] = useState(0)
    const [passwordShown, setPasswordShown] = useState(false)
    const [cpasswordShown, setCPasswordShown] = useState(false)
    const [mpasswordShown, setMPasswordShown] = useState(false)
    const [stateList, setStateList] = useState(stateData)
    const [error, setError] = useState({ password_strength: false, confirm_password_strength: false })
    const [accessPermissions, setAccessPermissions] = useState('')
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        setModalSignup(useFor ? Number(useFor) : 0)
    }, [useFor])

    useEffect(() => {
        if(getLoggedUserData()?.access_token){
            navigate(`/${partner}${URL?.BASE_USER}`)
        }
    })

    useEffect(() => {
        if (partnerDetails?.id) {
            let countryList = [partnerDetails?.facilities?.[0]?.country_code, 'CA', 'GB']
            if (isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode')) {
                countryList = [partnerDetails?.facilities?.[0]?.country_code, 'CA', 'GB']
            }
            dispatch(getVehicleDetailsList(countryList)).then(() => {
                let defaultCountry = countryData ? countryData?.[1]?.name : 'United States'
                setValue('country', defaultCountry)
                getStateByCountry(defaultCountry)
            })
        }
    }, [EMPTY_ARRAY, partnerDetails])

    useEffect(() => {
        const getAccessPermissionData = sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions')
        setAccessPermissions(getAccessPermissionData)
    }, [EMPTY_ARRAY, partnerDetails])



    const togglePasswordVisiblity = (e, key) => {
        if (key === 'password') {
            setPasswordShown(passwordShown ? false : true)
        }
        if (key === 'mpassword') {
            setMPasswordShown(mpasswordShown ? false : true)
        }
        if (key === 'cpassword') {
            setCPasswordShown(cpasswordShown ? false : true)
        }
    }

    const handleInputChange = (e) => {
        let formValue = getValues()?.[e.target.name]
        setValue(e.target.name, restrictInValidCharPassword(formValue))
        const { name } = e.target
        if (name == 'password') {
            setError({ ...error, password_strength: false })
        } else {
            setError({ ...error, confirm_password_strength: false })
        }
    }

    const handleSecondModal = () => {
        reset(formValues => ({
            ...formValues,
            username: '',
            password: ''
        }))
        setModalSignup(1)
        // setBackButtonHide(true)
    }


    const onSignIn = (data) => {
        setIsLoading(true)
        if (data?.username !== '' && data?.password !== '') {
            const payloadKeys = { 'client_id': getConfigDetails()?.CLIENT_ID, 'client_secret': getConfigDetails()?.CLIENT_SECRET, 'grant_type': 'password' }
            const finalPayload = { ...payloadKeys, ...data }
            finalPayload.password = encodePasswordBase(finalPayload.password)
            finalPayload.booking_label_id = bookingPartnerDetails?.brand_setting ? bookingPartnerDetails?.brand_setting?.user_id : ''
            dispatch(userLogin(finalPayload)).then((res) => {
                setIsLoading(false)
                if (res?.status === 201 && res?.data && res?.data !== null) {
                    localStorage?.setItem('userData', JSON.stringify(res?.data))
                    localStorage?.setItem('access_token', JSON.stringify(res?.data?.access_token))
                    notify('success', 'User Login Successfully')
                    // setIsLogin(true)
                    reset(formValues => ({
                        ...formValues,
                        'username': '',
                        'password': '',
                    }))
                    navigate(`/${partner}${URL?.BASE_USER}`)
                    //navigate(`${URL?.BASE_USER}`)
                    //window. location. reload(true)
                    // navigate(0)
                } else {
                    // setIsLogin(false)
                    notify('error', res?.errors?.message)
                }
            }).catch((errors) => {
                setIsLoading(false)
                notify('error', errors?.message)
                // setIsLogin(false)
            })
        }
    }

    const onSignUp = (data) => {
        setIsLoading(true)
        if (!validatePassword(data?.password)) {
            setIsLoading(false)
            setError({ ...error, password_strength: true })
            return
        } else if (!validatePassword(data?.cpassword)) {
            setIsLoading(false)
            setError({ ...error, confirm_password_strength: true })
            return
        }
        if (data?.cpassword === data?.password) {
            const payload = {
                'first_name': '',
                'last_name': '',
                'email': '',
                'phone': '',
                'confirm_password': '',
                'client_secret': getConfigDetails()?.CLIENT_SECRET,
                'base_url': `${window?.location?.toString()?.includes('rev-pass') ? getConfigDetails()?.revportalBASEURL : getConfigDetails()?.portalBASEURL}/${partner}`
                // 'base_url': `${window?.location?.toString()?.includes('rev-pass') ? getConfigDetails()?.revtransientURL : getConfigDetails()?.transientURL}/${partner}/${pushBack?.route}/${pushBack?.facility}`
            }
            const finalPayload = { ...payload, ...data }
            finalPayload['confirm_password'] = finalPayload?.cpassword
            delete finalPayload?.password
            delete finalPayload?.cpassword
            delete finalPayload?.username
            finalPayload.booking_label_id = bookingPartnerDetails?.brand_setting ? bookingPartnerDetails?.brand_setting?.user_id : ''

            dispatch(userSingUp(finalPayload)).then((res) => {
                setIsLoading(false)
                if (res?.status === 201) {
                    localStorage?.setItem('userData', JSON.stringify(res?.data))
                    localStorage?.setItem('access_token', JSON.stringify(res?.data?.access_token))
                    notify('success', 'Registration Successfully Completed')
                    const payloadKeys = { 'client_id': getConfigDetails()?.CLIENT_ID, 'client_secret': getConfigDetails()?.CLIENT_SECRET, 'grant_type': 'password' }

                    payloadKeys.username = data?.email
                    payloadKeys.password = data?.password
                    payloadKeys.booking_label_id = bookingPartnerDetails?.brand_setting ? bookingPartnerDetails?.brand_setting?.user_id : ''
                    dispatch(userLogin(payloadKeys)).then((res) => {
                        const userData = res?.data

                        if (userData) {
                            localStorage.setItem('isLoggedIn', true)
                            localStorage.setItem('userData', JSON.stringify(userData))
                            navigate(`/${partner}${URL?.BASE_USER}`)

                            //navigate(`${URL?.BASE_USER}`)
                            // window. location. reload(true)

                        } else {
                            notify(res?.errors?.message ? res?.errors?.message : 'Something went wrong, Please try again!')
                        }

                    }).catch((err) => {
                        const response = err?.errors

                        notify(response?.message ? response?.message : 'Something went wrong, Please try again!')

                    })

                    // setIsLogin(true)
                    reset(formValues => ({
                        ...formValues,
                        'first_name': '',
                        'last_name': '',
                        'email': '',
                        'phone': '',
                        'confirm_password': '',
                        'client_secret': getConfigDetails()?.CLIENT_SECRET
                    }))
                    navigate(`/${partner}${URL?.BASE_HOME}`)
                    // navigate(0)
                } else {
                    // setIsLogin(false)
                    notify('error', res?.errors?.message)
                }
            }).catch(() => {
                setIsLoading(false)
                notify('error', 'Something went wrong!')
                // setSignInModal(true)
            })
        } else {
            setIsLoading(false)
            notify('error', 'Password not match')
        }
    }

    const handlecountryChange = (e) => {
        const { value } = e.target
        getStateByCountry(value)
        setValue('zipcode', '')
    }
    const getStateByCountry = (value) => {
        let countryDatas = countryData?.filter((v) => v.name == value)
        dispatch(getVehicleModelList(partnerDetails?.facilities?.[0]?.country_code, countryDatas?.[0]?.id)).then((res) => {
            setStateList(res?.state)

            setValue('country', value)
        })

    }

    const handleBackButton = () => {
        reset(formValues => ({
            ...formValues,
            email: '',
            phone: '',
            first_name: '',
            cpassword: '',
            password: '',
        }))
        setModalSignup(0)
    }

    const handleForgotPassword = () => {
        navigate(`/${partner}${URL?.BASE_SEND_EMAIL_FORGOT_PASSWORD}`)

    }

    return (

        <div className='container'>
            <div className='row g-0 justify-content-center min-height-600'>
                {/* loggedInError={loggedInError} */}
                {/* <div className='col-sm-6 p-0'><Header page={'page'} /></div> */}
                <div className='col-sm-6 p-0'>
                    <main className='p-3 bg-white mt-3 mt-sm-5 border shadow-sm '>
                        <section id="forms" className="p-sm-2">
                            <div className='row justify-content-center'>
                                <div size={modalSingup === 1 ? 'lg' : null} >
                                    {modalSingup === 0 &&
                                        <form onSubmit={handleSubmit(onSignIn)}>
                                            <Modal.Header > <Modal.Title>Login</Modal.Title> </Modal.Header>
                                            <Modal.Body>
                                                <div className="mb-3">
                                                    <label htmlFor="exampleInputEmail1" className="form-label">User Name <span style={{ color: 'red' }}>*</span></label>
                                                    <input type="email" name='username' className="form-control" maxLength='40' minLength='1' placeholder="" {...register('username', {
                                                        required: true,
                                                        pattern: {
                                                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                            message: 'invalid email address'
                                                        }
                                                    })} />
                                                    {errors?.username?.type === 'required' && <span style={{ color: 'red' }}>This field is required</span>}
                                                    {errors?.username?.type === 'pattern' && <span style={{ color: 'red' }}>{errors?.username?.message}</span>}
                                                </div>

                                                <div className="mb-3 myiconset">
                                                    <label htmlFor="exampleInputPassword1" className="form-label">Password <span style={{ color: 'red' }}>*</span>
                                                        <span className="popoverSection position-relative"  >
                                                            <div className='small popoverContent position-absolute shadow-sm bg-white p-2 border'>Password must be between 8 and 15 characters long and include at least one uppercase letter, one lowercase letter, one digit (0-9), and one special character (!, @, $, %, ^, &, *, #,?,-). </div>
                                                            <i
                                                                className="fa fa-question-circle "
                                                            >
                                                            </i>
                                                        </span>
                                                    </label>
                                                    <input type={passwordShown ? 'text' : 'password'} name='password' className="form-control passwordInput" id="exampleInputPassword1"   {...register('password', { required: true })}
                                                        minLength={8}
                                                        maxLength={15} />
                                                    <i className={passwordShown ? 'fas fa-eye-slash loginPassIcon' : 'fas fa-eye loginPassIcon'} onClick={(e) => togglePasswordVisiblity(e, 'password')}></i>
                                                    {errors?.password?.type === 'required' && <span style={{ color: 'red' }}>This field is required</span>}
                                                </div>
                                                <div className='mb-3 cursor' >
                                                    <span className="form-label" onClick={() => { handleForgotPassword() }}>Forgot Password? </span>

                                                </div>

                                                <div className="mb-3">
                                                    <Button variant="primary" type='submit' className="btn btn-primary btn-lg w-100" onClick={handleSubmit}>
                                                        <div className='d-flex justify-content-center align-items-center'>
                                                            <span>Sign in </span>  <span className='ms-2'>
                                                                {isLoading ? <Circles
                                                                    height="20"
                                                                    width="20"
                                                                    style={{ display: 'inline-block' }}
                                                                    color="#ffffff"
                                                                    ariaLabel="circles-loading"
                                                                    visible={true}
                                                                /> : null}
                                                            </span>
                                                        </div>
                                                    </Button>
                                                </div>
                                                <div className="mb-3 text-center">
                                                    New on our platform? <a type='button' className='text-primary' role='button' onClick={handleSecondModal}>Create an account</a>
                                                </div>
                                            </Modal.Body>
                                        </form>
                                    }
                                    {modalSingup === 1 &&
                                        <form onSubmit={handleSubmit(onSignUp)}>
                                            <Modal.Header> <Modal.Title>Register your Account</Modal.Title></Modal.Header>
                                            <Modal.Body>
                                                <div className="checkinForm">
                                                    <h6 className='text-muted fw-semibold'>Login Info</h6>
                                                    <div className='row'>
                                                        <div className='col'>
                                                            <div className="mt-2">
                                                                <label htmlFor="" className="form-label">Email <span style={{ color: 'red' }}>*</span></label>
                                                                <input type="email" name='email' className="form-control" maxLength='40' minLength='1' placeholder="Enter your email" {...register('email', {
                                                                    required: true,
                                                                    pattern: {
                                                                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                                        message: 'invalid email address'
                                                                    }
                                                                })} />
                                                            </div>
                                                            {errors?.email?.type === 'required' && <span className="text-danger small">This field is required</span>}
                                                            {errors?.email?.type === 'pattern' && <span className="text-danger small">{errors?.email?.message}</span>}
                                                        </div>
                                                        <div className='col'>
                                                            <div className="mt-2">
                                                                <label htmlFor="" className="form-label">Phone <span style={{ color: 'red' }}>*</span></label>
                                                                <Controller
                                                                    name="phone"
                                                                    type="text"
                                                                    id="phone"
                                                                    control={control}
                                                                    rules={{
                                                                        required: true,
                                                                        minLength: {
                                                                            value: 10,
                                                                            message: 'Minimum 10 characters allowed',
                                                                        },
                                                                        maxLength: {
                                                                            value: 10,
                                                                            message: 'Maximum 10 characters allowed',
                                                                        },
                                                                    }}
                                                                    render={({ field }) => <MaskedInput
                                                                        maskGenerator={phoneMaskGenerator}
                                                                        className="form-control"
                                                                        {...field}
                                                                        maxLength={14}
                                                                        title="Please enter a valid phone number"
                                                                        onInvalid={e => e.target.setCustomValidity('Please enter phone number')}
                                                                        onInput={e => e.target.setCustomValidity('')}
                                                                        placeholder="Phone Number"
                                                                    />}
                                                                />
                                                            </div>
                                                            {errors?.phone?.type === 'required' && <span className="text-danger small">This field is required</span>}
                                                            {errors?.phone?.type === 'minLength' && <span className="text-danger small">{errors?.phone?.message}</span>}
                                                        </div>
                                                    </div>

                                                    <div className="row">
                                                        <div className="col-sm-6 myiconset">
                                                            <div className="mt-2">
                                                                <label htmlFor="" className="form-label">Password <span style={{ color: 'red' }}>*</span>
                                                                    <span className="popoverSection position-relative"  >
                                                                        <div className='small popoverContent position-absolute shadow-sm bg-white p-2 border'>Password must be between 8 and 15 characters long and include at least one uppercase letter, one lowercase letter, one digit (0-9), and one special character (!, @, $, %, ^, &, *, #,?,-). </div>
                                                                        <i
                                                                            className="fa fa-question-circle "
                                                                        >
                                                                        </i>
                                                                    </span></label>
                                                                <input className="form-control  passwordInput"
                                                                    name="password" placeholder="Create Password"
                                                                    {...register('password', {
                                                                        required: true,
                                                                        onChange: (e) => handleInputChange(e)
                                                                    })}
                                                                    type={mpasswordShown ? 'text' : 'password'} />
                                                            </div>
                                                            <i className={mpasswordShown ? 'fas fa-eye-slash iconset' : 'fas fa-eye iconset'} onClick={(e) => togglePasswordVisiblity(e, 'mpassword')}></i>
                                                            {errors?.password?.type === 'required' && <span className="text-danger small">This field is required</span>}
                                                            {(error?.password_strength) && <Form.Text className="text-danger">Password must be between 8 and 15 characters long and include at least one uppercase letter, one lowercase letter, one digit (0-9), and one special character (!, @, $, %, ^, &, *, #,?,-).</Form.Text>}
                                                        </div>
                                                        <div className="col-sm-6 myiconset">
                                                            <div className="mt-2">
                                                                <label htmlFor="" className="form-label">Confirm Password <span className="text-danger small">*</span>
                                                                    <span className="popoverSection position-relative"  >
                                                                        <div className='small popoverContent position-absolute shadow-sm bg-white p-2 border'>Password must be between 8 and 15 characters long and include at least one uppercase letter, one lowercase letter, one digit (0-9), and one special character (!, @, $, %, ^, &, *, #,?,-). </div>
                                                                        <i
                                                                            className="fa fa-question-circle "
                                                                        >
                                                                        </i>
                                                                    </span>
                                                                </label>
                                                                <input className="form-control  passwordInput"
                                                                    {...register('cpassword', {
                                                                        required: true,
                                                                        onChange: (e) => handleInputChange(e)
                                                                    })}
                                                                    name="cpassword" placeholder="Confirm Password"
                                                                    type={cpasswordShown ? 'text' : 'password'} />
                                                            </div>
                                                            <i className={cpasswordShown ? 'fas fa-eye-slash iconset' : 'fas fa-eye iconset'} onClick={(e) => togglePasswordVisiblity(e, 'cpassword')}></i>
                                                            {errors?.cpassword?.type === 'required' && <span className="text-danger small">This field is required</span>}
                                                            {(error?.confirm_password_strength) && <Form.Text className="text-danger small">Password must be between 8 and 15 characters long and include at least one uppercase letter, one lowercase letter, one digit (0-9), and one special character (!, @, $, %, ^, &, *, #,?,-).</Form.Text>}
                                                        </div>
                                                    </div>
                                                    <hr />
                                                    <h6 className='text-muted fw-semibold'>Contact Info</h6>
                                                    <div className='row row-cols-sm-2 row-cols-1'>
                                                        <div className='col'>
                                                            <div className="mb-2">
                                                                <label htmlFor="" className="form-label">First Name <span style={{ color: 'red' }}>*</span></label>
                                                                <input type="text" className="form-control" name='first_name' id="first_name" placeholder="Enter First Name" {...register('first_name', { required: true })} />
                                                                {errors?.first_name?.type === 'required' && <span className="text-danger small">This field is required</span>}
                                                            </div>
                                                        </div>
                                                        <div className='col'>
                                                            <div className="mb-2">
                                                                <label htmlFor="" className="form-label">Last Name <span style={{ color: 'red' }}>*</span></label>
                                                                <input type="text" name='last_name' className="form-control" id="last_name" placeholder="Enter Last Name" {...register('last_name', { required: true })} />
                                                                {errors?.last_name?.type === 'required' && <span className="text-danger small">This field is required</span>}
                                                            </div>
                                                        </div>
                                                        <div className='col'>
                                                            <div className='mb-2'>
                                                                <label htmlFor="" className="form-label">Company Name</label>
                                                                <input type="text" name='company_name' className="form-control" id="company_name" placeholder="Enter Company Name" {...register('company_name')} />
                                                            </div>
                                                        </div>
                                                        <div className='col'>
                                                            <div className='mb-2'>
                                                                <label htmlFor="" className="form-label">Address 1 <span style={{ color: 'red' }}>*</span></label>
                                                                <input type="text" name='address1' className="form-control" id="address1" placeholder="Enter Address 1" {...register('address1', { required: true })} />
                                                                {errors?.address1?.type === 'required' && <span className="text-danger small">This field is required</span>}
                                                            </div>
                                                        </div>
                                                        <div className='col'>
                                                            <div className='mb-2'>
                                                                <label htmlFor="" className="form-label">Address 2</label>
                                                                <input type="text" name='address2' className="form-control" id="address2" placeholder="Enter Address 2" {...register('address2')} />
                                                            </div>
                                                        </div>
                                                        <div className='col'>
                                                            <div className='mb-2'>
                                                                <label htmlFor="" className="form-label">City <span style={{ color: 'red' }}>*</span></label>
                                                                <input type="text" name='city' className="form-control" id="city" placeholder="Enter City" {...register('city', { required: true })} />
                                                                {errors?.city?.type === 'required' && <span className="text-danger small">This field is required</span>}
                                                            </div>
                                                        </div>
                                                        <div className='col'>
                                                            <div className='mb-2'>
                                                                <label htmlFor="" className="form-label">Country <span style={{ color: 'red' }}>*</span></label>
                                                                <Controller
                                                                    name="country"
                                                                    id='country'
                                                                    control={control}
                                                                    defaultValue=""
                                                                    className='form-select'
                                                                    rules={{ required: true }}
                                                                    render={({ field }) => <select type="select" className='form-select' name='country' id='country' {...field} onChange={(e) => { field.onChange(e); handlecountryChange(e) }}>
                                                                        <option value=''>Select Country</option>
                                                                        {countryData?.map((item, index) => <option key={(index + 1)} value={item?.name} >{item?.name}</option>)}
                                                                    </select>}
                                                                />
                                                                {errors?.country?.type === 'required' && <span className="text-danger small">This field is required</span>}
                                                            </div>
                                                        </div>
                                                        <div className='col'>
                                                            <div className='mb-2'>
                                                                <label htmlFor="" className="form-label">State <span style={{ color: 'red' }}>*</span></label>
                                                                <Controller
                                                                    name="state"
                                                                    id='state'
                                                                    control={control}
                                                                    defaultValue=""
                                                                    className='form-select'
                                                                    rules={{ required: true }}
                                                                    render={({ field }) => <select className='form-select' name="state" id='state' {...field}>
                                                                        <option value=''>Select State</option>
                                                                        {stateList?.map((item, itemIndex) => <option key={(itemIndex + 1)} value={item?.id}>{item?.state_code}</option>)}
                                                                    </select>}
                                                                />
                                                                {errors?.state?.type === 'required' && <span className="text-danger small">This field is required</span>}
                                                            </div>
                                                        </div>

                                                        <div className='col'>
                                                            <div className='mb-2'>
                                                                <label htmlFor="" className="form-label">Zip / Postal Code <span style={{ color: 'red' }}>*</span></label>
                                                                <input type="text" name='zipcode' minLength='5' maxLength='6' className="form-control" id="zipcode" placeholder="Enter Zip/Postal Code"
                                                                    {...register('zipcode', { required: true, minLength: 5, maxLength: 6 })}
                                                                    onKeyPress={(e) => isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') && getValues()?.country == 'Canada' ? restrictSpecialChar(e) : restrictInputValues(e)}
                                                                    onPaste={(e) => {
                                                                        e.preventDefault()
                                                                        return false
                                                                    }}
                                                                />
                                                                {errors?.zipcode?.type === 'required' && <span className="text-danger small">This field is required</span>}
                                                                {errors?.zipcode?.type === 'minLength' && <span className="text-danger small">{isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') ? 'Minimum 5 characters allowed' : 'Minimum 5 numbers allowed'}</span>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Modal.Body>
                                            <Modal.Footer className="mt-3">
                                                <button className="btn btn-outline-secondary me-auto" type='button' onClick={handleBackButton} ><i className="fa fa-angle-left"></i> Back To Login</button>
                                                <Button type="submit" className="btn btn-primary">
                                                    <div className='d-flex aling-items-center'>
                                                        <span>Submit</span> <span className='ms-2'>
                                                            {isLoading ? <Circles
                                                                height="20"
                                                                width="20"
                                                                style={{ display: 'inline-block' }}
                                                                color="#ffffff"
                                                                ariaLabel="circles-loading"
                                                                visible={true}
                                                            /> : null}
                                                        </span>
                                                    </div>
                                                </Button>
                                            </Modal.Footer>
                                        </form>
                                    }
                                </div>
                            </div>
                        </section>
                    </main>
                </div>
            </div>
        </div>
    )
}


Login.propTypes = {
    dispatch: PropTypes.func,
    data: PropTypes.object,
    loaderSing: PropTypes.bool,
    notify: PropTypes.func,
    useFor: PropTypes.number,
    stateData: PropTypes.array,
    countryData: PropTypes.array,
    partnerDetails: PropTypes.object,
    bookingPartnerDetails: PropTypes.object,

}

Login.defaulProps = {
    dispatch: noop,
    data: EMPTY_OBJECT,
    loaderSing: false,
    notify: noop,
    useFor: '0',
    stateData: EMPTY_ARRAY,
    countryData: EMPTY_ARRAY,
    partnerDetails: EMPTY_OBJECT,

}

function mapStateToProps({ loginReducer, vehicleListReducer, PartnerReducer }) {
    return {
        loaderSing: loginReducer?.loader,
        stateData: vehicleListReducer?.data?.state,
        countryData: vehicleListReducer?.data?.country,
        bookingPartnerDetails: PartnerReducer?.partnerDetails?.data
    }
}
export default connect(mapStateToProps)(Login)